import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TransportDataViewModel } from 'src/app/receipt-long-op/view-models/transport-data.view-model';
import { firstValueFrom, Observable } from 'rxjs';
import { ExpandableComponent, LabelledTextBoxComponent, MessageResourceManager, NTSTranslatePipe } from '@nts/std';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { BaseStepComponent } from '../base-step.component';
import { WeaSettingsDataDto } from 'src/app/create-expense-annotation-long-op/api-clients/dto/wea-settings-data.dto';
import { ManageTransportData } from 'src/app/wea-settings/domain-models/manage-transport-data';

@UntilDestroy()
@Component({
  selector: 'nts-transport-data-step',
  templateUrl: './transport-data-step.component.html',
  styleUrls: ['./transport-data-step.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NTSTranslatePipe,
    SvgIconComponent,
    ExpandableComponent,
    LabelledTextBoxComponent
  ]
})
export class TransportDataStepComponent extends BaseStepComponent<TransportDataViewModel> {

  untilDestroyed(): <U>(source: Observable<U>) => Observable<U> {
    return untilDestroyed(this);
  }

  get currentConfiguration(): WeaSettingsDataDto {
    return this.rootViewModel.params.expenseData.configuration;
  }

  get transportDataConfiguration(): ManageTransportData {
    return this?.currentConfiguration?.manageTransportData;
  }

  async onViewModelLoaded() {
    this.receiptStepsService.stepLoading.next(true);

    const viewModel = this.receiptStepsService.getCurrentState() as TransportDataViewModel;

    const queryParams = await firstValueFrom(this.routeStateService.queryParams);
    const expenseAnnotationId = parseInt(queryParams['expenseAnnotationId'], 10);
    const remoteExpense = queryParams['remoteExpense'] === 'true';

    viewModel.initPresentationLogic(
      expenseAnnotationId,
      remoteExpense,
      this.rootViewModel.params.expenseSelection.expenseClassification.value,
      this.rootViewModel.params.expenseState,
      !(await this.isReadOnly(this.rootViewModel))
    );

    this.receiptStepsService.orchestratorViewModel.rootViewModelModified.pipe(untilDestroyed(this)).subscribe(() => {
      viewModel.validateStep();
    });

    viewModel.validateStep();

    this.inIframe = this.activatedRoute.snapshot.queryParams['iframe'] === 'true' || window.self !== window.top;


    this.receiptStepsService.stepLoading.next(false);

    this.viewModel = viewModel;

    const customTitle = viewModel.newLabels().value[viewModel.currentExpenseClassificationType];
    const title = customTitle ?? MessageResourceManager.Current.getMessage('ExpenseClassification_' + viewModel.expenseClassificationEnum[viewModel.currentExpenseClassificationType]);
    this.telemetryService.trackPageView({ name: title });
  };
}

